/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getGpcComps as getGpcCompsService } from 'dashboard409a/services/dashboard';
import { CompsDataType, IGetGpcCompsResponse } from 'dashboard409a/services/types';
import { IGpcCompsState } from './types';

const initialState: IGpcCompsState = {
  loading: false,
  valueOverTime: null,
  rateOfChange: null,
  currentValue: null,
  medians: null,
};

export const getGpcComps = createAsyncThunk<
  { response: IGetGpcCompsResponse; dataType: CompsDataType },
  { dateId: number; dataType: CompsDataType }
>(
  'gpcComps/getGpcComps',
  async ({ dateId, dataType }, thunkAPI) => {
    try {
      const response = await getGpcCompsService(dateId, dataType);
      return { response, dataType };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const gpcCompsSlice = createSlice({
  name: 'gpcComps',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getGpcComps.pending, state => {
        state.loading = true;
      })
      .addCase(getGpcComps.fulfilled, (state, { payload }) => {
        state.loading = false;
        if (payload.dataType === CompsDataType.VALUE_OVER_TIME) {
          state.valueOverTime = payload.response.value_over_time;
        } else if (payload.dataType === CompsDataType.RATE_OF_CHANGE) {
          state.rateOfChange = payload.response.rate_of_change;
        } else if (payload.dataType === CompsDataType.CURRENT_AND_MEDIANS) {
          state.currentValue = payload.response.current_value;
          state.medians = payload.response.medians;
        }
      })
      .addCase(getGpcComps.rejected, state => {
        state.loading = false;
      });
  },
});

export default gpcCompsSlice.reducer;
